import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import * as loaderAction from "../../redux/loader/action";
import cx from "classnames";
import StatusMessage from "./StatusMessage";

function Slides(props) {
  const { handle_submit } = props;
  const joining_data = _.get(props, "paramsReducer.gameObj.joining");
  const hero_label = _.get(joining_data, "slides.hero_label", "Link to Hero");
  const slidekick_label = _.get(
    joining_data,
    "slides.slidekick_label",
    "Link to Slidekick"
  );
  const slidekick_only = _.get(
    joining_data,
    "slides.slidekick_only",
    "Slidekick only"
  );
  const game_state = _.get(props, "gameReducer.roomObj.game_state");
  const slidekick_status = _.get(game_state, "slidekick_status");
  const hero_status = _.get(game_state, "hero_status");

  const { slides_hero_link, handle_hero_link } = props;
  const { slides_slidekick_link, handle_slidekick_link } = props;
  const { slides_slidekick_only, handle_slidekick_only } = props;
  const { show_slides_status } = props;

  useEffect(() => {
    if (slides_slidekick_only) {
      if (slidekick_status && slidekick_status === "Good") {
        props.setopenRoomDisabled(false);
      } else {
        props.setopenRoomDisabled(true);
      }
    } else {
      if (
        slidekick_status &&
        slidekick_status === "Good" &&
        hero_status &&
        hero_status === "Good"
      ) {
        props.setopenRoomDisabled(false);
      } else {
        props.setopenRoomDisabled(true);
      }
    }
  }, [slidekick_status, hero_status, slides_slidekick_only]);

  const on_submit = (e, link, type) => {
    // e.preventDefault();
    handle_submit(link, type, slides_slidekick_only, "google_slides");
  };

  return (
    <div className="slides-container">
      <div
        className={cx("hero-container", { disabled: slides_slidekick_only })}
        disabled={slides_slidekick_only}
      >
        <h1>{hero_label}</h1>
        <div className="d-flex justify-content-between">
          <input
            type="text"
            placeholder="Paste link to slides here..."
            className="form-control"
            value={slides_hero_link}
            onChange={(e) => handle_hero_link(e.target.value, "slides")}
          />
          <button
            className="btn"
            onClick={(e) => on_submit(e, slides_hero_link, "hero")}
          >
            OK
          </button>
        </div>
        {show_slides_status && hero_status && <StatusMessage hero={true} />}
      </div>
      <div className="slideKick-container">
        <div className="d-flex justify-content-between align-items-center">
          <h1>{slidekick_label}</h1>
          <div className="label-check">
            <input
              type="checkbox"
              id="slideKick-only"
              onClick={() => handle_slidekick_only("slides")}
              checked={slides_slidekick_only}
              className="mr-2"
            />
            <label htmlFor="slideKick-only" className="slideKick-only">{slidekick_only}</label>
          </div>
        </div>
        <div className="d-flex justify-content-between">
          <input
            type="text"
            placeholder="Paste link to slides here..."
            className="form-control"
            value={slides_slidekick_link}
            onChange={(e) => handle_slidekick_link(e.target.value, "slides")}
          />
          <button
            className="btn"
            onClick={(e) => on_submit(e, slides_slidekick_link, "slidekick")}
          >
            OK
          </button>
        </div>
        {show_slides_status && slidekick_status && (
          <StatusMessage slidekick={true} />
        )}
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
  paramsReducer: state.paramsReducer,
});
const mapDispatchToProps = (dispatch) => {
  return {
    setIsLoading: (data) => dispatch(loaderAction.setIsLoading(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Slides);
